import { render, staticRenderFns } from "./CustomsDocsModal.vue?vue&type=template&id=73f1c1c1&scoped=true"
import script from "./CustomsDocsModal.vue?vue&type=script&lang=js"
export * from "./CustomsDocsModal.vue?vue&type=script&lang=js"
import style0 from "./CustomsDocsModal.vue?vue&type=style&index=0&id=73f1c1c1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f1c1c1",
  null
  
)

export default component.exports